import React, {useEffect, useState} from "react";
import Util from "../../../../../util";
import data from "../../../../../data";

/**
 * Options and optionals (some subactivities are optional. Optional subactivities are treated like options; i.e. buyer can select them)
 * @param {*} param0 
 */
function CustomizeOptions({activity, regionCode, participantCount, subactivities, options, onChangeOptions, onChangeSubactivities}) {
  // state
  const [optionals, setOptionals] = useState([]);

  // effects
  useEffect(() => {
    setOptionals(data.Activity.getOptionalSubactivities(activity, regionCode, participantCount))
  }, [activity, regionCode, participantCount])

  // no optional subactivities? no render
  /*
  if(!optionals) {
    return null
  }
  */
  // no region? no render
  if(!regionCode) {
    return null
  }

  const toggleSubactivity = (subactivity, action) => {
    const updatedSubactivities = subactivities.filter(sa => sa.activity_id !== subactivity.activity_id)
    if(action === "add") {
      updatedSubactivities.push(subactivity)
    }
    onChangeSubactivities(updatedSubactivities)
  }

  // gather all kinds of options
  let optionItems = data.Activity.getOptions(activity, regionCode).map(o => {
    // select options
    let subitems = []

    // get the selected value
    let selectedValue = null
    let selectedOption = options.find(opt => opt.id === o._id)
    if(selectedOption) {
      selectedValue = JSON.stringify({id:selectedOption.id, count:selectedOption.count})
    }

    // create <option> components
    for(let i=o.minUnits;i <= o.maxUnits; i+=1 ) {
      let value = JSON.stringify({id:o._id, count:i})

      // use default if nothing is selected
      if(!selectedValue && i===0) {
        selectedValue = value
      }

      subitems.push(
        <option 
          key={`${o._id}-${i}`} 
          value={value}
        >
          {`${i} (+ ${Util.Format.currency(i*o.price, true)})`}
        </option>
      )
    } 
    return (
      <div key={o._id} className="customize-option">
        <h3>{o.name["de"]}</h3>
        <p className="description">{o.description["de"]}</p>
        <select 
          value={selectedValue} 
          onChange={(e) => {
            let option = JSON.parse(e.target.value)
            let updatedOptions = options.filter(opt => opt.id !== option.id)
            updatedOptions.push({id:option.id, count:Number(option.count)})
            onChangeOptions(updatedOptions)
          }}
        >{subitems}</select>
      </div>
    ) 
  })

  // gather optional subactivities
  let optionalItems = optionals.map(opt => {
    const value = subactivities.some(sa => String(sa.activity_id) === String(opt.activity_id)) ? "active" : "inactive"
    return (
      <div key={opt.activity_id} className="customize-option">
        <h3>{opt.title}</h3>
        <p className="description">{opt.description}</p>
        <select 
          value={value}
          onChange={(e) => {
            let v = e.target.value
            toggleSubactivity(opt, v === "inactive" ? "remove" : "add")
          }}
        >
          <option key={0} value="inactive">
            0 (+ {Util.Format.currency(0, true)})
          </option>
          <option key={1} value="active">
            {`${opt.participantCount} (+ ${Util.Format.currency(opt.price, true)})`}
          </option>
        </select>
      </div>
    )
  })

  // no optional and not options? render nothing
  if(optionItems.length === 0 && optionalItems.length === 0) {
    return null;
  }

  // render
  return (
    <div className="customize-options">
      <h2>Optionen</h2>
      {optionalItems.length > 0 ? <div>{optionalItems}</div> : null}
      {optionItems.length > 0 ? <div>{optionItems}</div> : null}
    </div>
  )
}

export default CustomizeOptions